interface Props {
  onBack: () => void;
}

const KERN = [
  { label: "Meldingen gelogd", waarde: "44", sub: "10:00 — 00:11" },
  { label: "Bezoekers", waarde: "10.000", sub: "5 area's · 47 acts" },
  { label: "Weer", waarde: "CODE GEEL", sub: "Nationaal Hitteplan actief" },
  { label: "Ontruimingen", waarde: "0", sub: "terrein vrijgegeven 23:50" },
] as const;

export function US26ArchiefView({ onBack }: Props) {
  return (
    <div className="min-h-full safe-top safe-bottom flex flex-col">
      <header className="px-5 pt-6 pb-4 flex items-center justify-between">
        <button
          onClick={onBack}
          aria-label="Terug naar overzicht"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-zinc-200 text-2xs uppercase font-semibold"
          style={{ letterSpacing: "0.18em" }}
        >
          <span aria-hidden="true">←</span>
          Overzicht
        </button>
        <div className="flex items-center gap-2.5">
          <span className="w-1 h-5 bg-zinc-600 rounded-full" />
          <span
            className="text-zinc-500 text-[10px] font-semibold uppercase"
            style={{ letterSpacing: "0.2em" }}
          >
            US26 · ARCHIEF
          </span>
        </div>
      </header>

      <main
        className="flex-1 px-5 pb-10 max-w-2xl w-full mx-auto space-y-4"
        aria-label="UltraSonic 2026 · archief"
      >
        <div>
          <h1
            className="text-zinc-200 text-lg font-semibold tracking-tight mb-1"
            style={{ letterSpacing: "-0.015em" }}
          >
            UltraSonic 2026 · archief
          </h1>
          <p className="text-zinc-600 text-sm mb-0">
            11 juli 2026 · Maarsseveense Plassen
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {KERN.map((k) => (
            <div
              key={k.label}
              className="rounded-2xl bg-ink-925 p-4"
              style={{ border: "1px solid rgba(255,255,255,0.06)" }}
            >
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                {k.label}
              </div>
              <div className="text-zinc-100 text-xl font-semibold mt-1 tabular">
                {k.waarde}
              </div>
              <div className="text-2xs text-zinc-500 mt-0.5">{k.sub}</div>
            </div>
          ))}
        </div>

        <div
          className="rounded-2xl px-4 py-3"
          style={{
            background: "rgba(94,234,212,0.04)",
            border: "1px solid rgba(94,234,212,0.14)",
          }}
        >
          <div className="text-2xs tracking-eyebrow uppercase text-accent mb-1.5">
            Volledig dossier
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Het complete CP-log (44 tijdgestempelde regels) staat in het
            officiële NEXXT-log (260711 — CP log US26) en het eventrapport van
            13 juli — inclusief tijdlijn, meldingen per categorie en zes
            belegde verbeterpunten. Twee incidenten adequaat afgehandeld: de
            hangmatconstructie (3 min vóór bezwijken gesignaleerd) en twee
            zwemmers (binnen 4 min uit het water).
          </p>
        </div>
      </main>
    </div>
  );
}
